document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.site-header');
    
    let mouseX = 0;
    let mouseY = 0;
    let isMouseOverHeader = false;

    // Track mouse movement
    document.addEventListener('mousemove', function(e) {
        mouseX = e.clientX / window.innerWidth * 2 - 1;
        mouseY = e.clientY / window.innerHeight * 2 - 1;
    });

    // Track when mouse enters/exits header
    header.addEventListener('mouseenter', function() {
        isMouseOverHeader = true;
    });

    header.addEventListener('mouseleave', function() {
        isMouseOverHeader = false;
    });

    // Animate header based on mouse position
    function animateHeader() {
        if (isMouseOverHeader) {
            const rotateX = (mouseY * 10);
            const rotateY = (-mouseX * 10);
            
            header.style.transform = `rotateX(${rotateX}deg) rotateY(${rotateY}deg) translateZ(10px)`;
        } else {
            // Return to center position
            header.style.transform = 'translateZ(10px)';
        }
        
        requestAnimationFrame(animateHeader);
    }

    // Start the animation loop
    animateHeader();

    // Keep the existing scroll shadow effect
    window.addEventListener('scroll', function() {
        if (window.pageYOffset > 50) {
            header.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
        } else {
            header.style.boxShadow = '';
        }
    });
});